import locationData from "../static/data/geo/tinh_tp.json";
import districtData from "../static/data/geo/quan_huyen.json";
import wardData from "../static/data/geo/xa_phuong.json";

// const BASE_URL_STATIC = "https://deyrjyz3hrcel.cloudfront.net";
// const BASE_URL_STATIC = "https://ts-res-staging.tuoitre.vn";
const BASE_URL_STATIC="https://res-eduzone.tuoitre.vn"

export const groupMajors = [
  [
    {
      label: "Toán và thống kê",
      icon: `/images/toan-va-thongke.svg`,
    },
    {
      label: "Thú y",
      icon: `/images/thu-y.svg`,
    },
    {
      label: "Sức khỏe",
      icon: `/images/suc-khoe.svg`,
    },
    {
      label: "Sản xuất và chế biến",
      icon: `/images/san-xuat.svg`,
    },
    {
      label: "Pháp luật",
      icon: `/images/phap-luat.svg`,
    },
    {
      label: "Nông, lâm nghiệp và thủy sản",
      icon: `/images/nong-lam-nghiep.svg`,
    },
    {
      label: "Nhân văn",
      icon: `/images/nhan-van.svg`,
    },
    {
      label: "Du lịch, khách sạn, thể thao và dịch vụ cá nhân",
      icon: `/images/du-lich.svg`,
    },
  ],
  [
    {
      label: "Dịch vụ xã hội",
      icon: `/images/dich-vu-xa-hoi.svg`,
    },
    {
      label: "Dịch vu vận tải",
      icon: `/images/dich-vu-van-tai.svg`,
    },
    {
      label: "Công nghệ kỹ thuật",
      icon: `/images/cong-nghe-ky-thuat.svg`,
    },
    {
      label: "Báo chí và thông tin",
      icon: `/images/bao-chi.svg`,
    },
    {
      label: "Khoa học đời sống",
      icon: `/images/khoa-hoc-doi-song.svg`,
    },
    {
      label: "An ninh, quốc phòng",
      icon: `/images/an-ninh.svg`,
    },
    {
      label: "Nghệ thuật",
      icon: `/images/nghe-thuat.svg`,
    },
    {
      label: "Khoa học giáo dục, đào tạo giáo viên",
      icon: `/images/khoa-hoc-giao-duc.svg`,
    },
  ],
  [
    {
      label: "Môi trường và bảo vệ môi trường",
      icon: `/images/moi-truong.svg`,
    },
    {
      label: "Máy tính và công nghệ thông tin",
      icon: `/images/may-tinh.svg`,
    },
    {
      label: "Kỹ thuật",
      icon: `/images/ky-thuat.svg`,
    },
    {
      label: "Kinh doanh và quản lý",
      icon: `/images/kinh-doanh.svg`,
    },
    {
      label: "Môi trường và bảo vệ môi trường",
      icon: `/images/moi-truong-va-bao-ve.svg`,
    },
    {
      label: "Kiến trúc và xây dựng",
      icon: `/images/kien-truc.svg`,
    },
    {
      label: "Khoa học xã hội và hành vi",
      icon: `/images/khoa-hoc-xa-hoi.svg`,
    },
    {
      label: "Khoa học tự nhiên",
      icon: `/images/khoa-hoc-tu-nhien.svg`,
    },
  ],
];
export const listSearchMajors = [
  [
    {
      icon: `/images/toan-va-thong-ke.svg`,
      label: "Toán và thống kê",
    },
    {
      icon: `/images/khoa-hoc-va-doi-song.svg`,
      label: "Khoa học đời sống",
    },
    {
      icon: `/images/dao-tao-giao-vien.svg`,
      label: "Khóa học giáo dục, đào tạo giáo viên",
    },
  ],
  [
    {
      icon: `/images/major-thu-y.svg`,
      label: "Thú y",
    },
    {
      icon: `/images/may-tinh-va-cong-nghe-thong-tin.svg`,
      label: "Máy tính và công nghệ thông tin",
    },
    {
      icon: `/images/majors-toan-va-thong-ke.svg`,
      label: "Toán và thống kê",
    },
  ],
  [
    {
      icon: `/images/majors-dich-vu-xa-hoi.svg`,
      label: "Dịch vụ xã hội",
    },
    {
      icon: `/images/majors-cong-nghe-ky-thuat.svg`,
      label: "Công nghệ kỹ thuật",
    },
    {
      icon: `/images/majors-kien-truc-va-xay-dung.svg`,
      label: "Kiến trúc và xây dựng",
    },
  ],
];
export const getProvinces = (type) => {
  if (type === "array") {
    const result = [];
    const topProvinces = [];
    let i = 0;
    for (let key in locationData) {
      if (locationData[key].code === "01" || locationData[key].code === "79") {
        topProvinces.push({
          ...locationData[key],
        });
      } else {
        result[i++] = {
          ...locationData[key],
        };
      }
    }
    return [
      ...topProvinces,
      ...result.sort((a, b) => {
        if (a.slug < b.slug) {
          return -1;
        }
        if (a.slug > b.slug) {
          return 1;
        }
        return 0;
      }),
    ];
  } else {
    return locationData;
  }
};

export const getProvinceWithCode = (provinceCode) => {
  if (!provinceCode) return {};

  const listProvinces = getProvinces("array");

  const result = listProvinces.find(({ code }) => provinceCode == code);

  return result ? result : {};
};

export const getAllDistrict = () => {
  return districtData;
};
export const getAllWard = () => {
  return districtData;
};

export const getProvinceItemByCode = (code) => {
  const item = Object.values(locationData).find(
    (item) => item.code === String(code)
  );
  return item.name_with_type;
};

export const getDisTrictByProvinceCode = (parent_code) => {
  return Object.values(districtData).filter(
    (item) => item.parent_code === String(parent_code)
  );
};
export const getAllWardByDistrictCode = (parent_code) => {
  return Object.values(wardData).filter(
    (item) => item.parent_code === String(parent_code)
  );
};

export const groupMajorsIcon = [
  // toan ve thongke
  `${BASE_URL_STATIC}/storages/2025-08-14/1f926b51138e4ab6b652d4718101160c.svg`,
  // thu y
  `${BASE_URL_STATIC}/storages/2025-08-14/5060b6151294494cb23440b50c5571f2.svg`,
  // suc khoe
  `${BASE_URL_STATIC}/storages/2025-08-14/6b7fffd486c2438a9515be342d30266b.svg`,
  //san xuat
  `${BASE_URL_STATIC}/storages/2025-08-14/1543610cc4ba4bc69aaf00daec17e580.svg`,
  //phap luat
  `${BASE_URL_STATIC}/storages/2025-08-14/a5af3872e4954e24b410d4f1a003127e.svg`,
  //nong lam
  `${BASE_URL_STATIC}/storages/2025-08-14/c6f99f6f10bf4f069efdcca99e6901ec.svg`,
  // nhan van
  `${BASE_URL_STATIC}/storages/2025-08-14/13841392cde0429f8466d5371c5dc2f8.svg`,
  //du lich
  `${BASE_URL_STATIC}/storages/2025-08-14/4d9254ef922242d195f9ad4dfe3c70dc.svg`,
  //dich vu xa hoi
  `${BASE_URL_STATIC}/storages/2025-08-14/48cf867f94e14b42a2b25281f1607f3c.svg`,
  //dich vu van tai
  `${BASE_URL_STATIC}/storages/2025-08-14/f47bfbe3917a4cfbb1d945d1c5a51687.svg`,
  //cong nghe ky thuat
  `${BASE_URL_STATIC}/storages/2025-08-14/4869e3f7141f4e6aa47d26bf68729ffe.svg`,
  //bao chi
  `${BASE_URL_STATIC}/storages/2025-08-14/b900d0314afd43ab9f5081c6cee2b37f.svg`,
  //khoa hoc doi song
  `${BASE_URL_STATIC}/storages/2025-08-14/48bf8b352a3241a0971e26355c568dc8.svg`,
  //an ninh
  `${BASE_URL_STATIC}/storages/2025-08-14/1ca1190e18da4fd29012e0805f874c99.svg`,
  // nghe thuat
  `${BASE_URL_STATIC}/storages/2025-08-14/6b6ebb3fe9bc4d32a4db4390817105da.svg`,
  //khoa hoc giao duc
  `${BASE_URL_STATIC}/storages/2025-08-14/7eaaece2e15b48449fe2431ae40e442c.svg`,
  // moi truong
  `${BASE_URL_STATIC}/storages/2025-08-14/93c38935cc914abab1af0e17760cda25.svg`,
  // may tinh
  `${BASE_URL_STATIC}/storages/2025-08-14/9e01bb67b8ef4547b7a96141b111f8d6.svg`,
  // kinh doanh
  `${BASE_URL_STATIC}/storages/2025-08-14/91dd912c01fe4c40bb8678010c8614e8.svg`,
  // moi truong va bao ve
  `${BASE_URL_STATIC}/storages/2025-08-14/2ccb3ed14b23451caf2a0e10cfd6c0c0.svg`,
  // ky thuat
  `${BASE_URL_STATIC}/storages/2025-08-14/7891736669994c96bd1c4e5f47c76435.svg`,
  //khoa hoc xa hoi
  `${BASE_URL_STATIC}/storages/2025-08-14/c31d76779b5f4ee0bc5a7dc0f61cb397.svg`,
  //kho hoc tu nhien
  `${BASE_URL_STATIC}/storages/2025-08-14/465818fe67c54ba18b4ad88c0d9da1c4.svg`,
  //kien truc
  `${BASE_URL_STATIC}/storages/2025-08-14/a6f7bf92772c45018645bc5f74e2ebeb.svg`,
];
